module.exports = __webpack_public_path__ + "assets/img/CM_Icon.ef91e7ec.png";